import DefaultScores from 'components/commandpanel/ExperimentPanel/DefaultScores/DefaultScores';
import MarcoScore from 'components/commandpanel/ExperimentPanel/MarcoScore/MarcoScore';
import RMTabs from 'components/customComponents/Controls/RMTabs';
import { ITabItem } from 'components/tab';
import React from 'react';
import { useRMDispatch, useRMSelector } from 'redux/hooks';
import {
  useCurrentSelectedWellDropDetails,
  useWellScores,
} from 'redux/hooks/searchnFilter';
import {
  markDisputedScores,
  moveNextSearchResultItem,
} from 'redux/reducers/searchnFilterReducer';
import ScoringTools from 'components/commandpanel/ExperimentPanel/ScoringTools/ScoringTools';
import { useAllScoresGroups } from 'redux/hooks/common';
import { selectAutoSelectNextWell } from 'redux/selectors/StateSelectors';
import { batch } from 'react-redux';
import { DisputedScoresIds } from 'business/models/Models';
import { scoreWellsThunk } from 'redux/thunks/searchnFilter';
import { ScoresOfWellDrops } from 'components/Experiment/constants';
const ScoresPanel = () => {
  const dispatch = useRMDispatch();
  const wellDropDetails = useCurrentSelectedWellDropDetails();
  const currentWellScores = useWellScores(
    wellDropDetails?.dropId,
    wellDropDetails?.imageBatchId,
  );
  const selectedWellScores = currentWellScores ? [currentWellScores] : [];

  const scoresOptionsList = useAllScoresGroups();
  const autoSelectNextWell = useRMSelector(selectAutoSelectNextWell);
  if (!wellDropDetails) {
    return null;
  }

  const applyScoring = (wellDropScoreId: number, wellDropScoreGroupId: number) => {
    if (autoSelectNextWell) {
      batch(() => {
        dispatch(moveNextSearchResultItem());
        dispatch(
          scoreWellsThunk({
            wellDropScoreId,
            wellDropScoreGroupId,
            selectedWellDetails: [wellDropDetails],
            selectedWellScores,
          }),
        );
      });
    } else {
      dispatch(
        scoreWellsThunk({
          wellDropScoreId,
          wellDropScoreGroupId,
          selectedWellDetails: [wellDropDetails],
          selectedWellScores,
        }),
      );
    }
  };

  const handleOnMarkDisputedScore = (disputedScoreGroupsIds: DisputedScoresIds[]) => {
    dispatch(
      markDisputedScores({
        dropId: wellDropDetails?.dropId,
        imageBatchId: wellDropDetails?.imageBatchId,
        disputedScoreGroupsIds,
      }),
    );
  };
  const tabItems: ITabItem[] = [
    {
      title: 'Filter',
      eventKey: 'filter',
      content: (
        <ScoringTools
          scoresOptionsList={scoresOptionsList}
          selectedWellsScores={selectedWellScores as ScoresOfWellDrops[][]}
          wellDetails={wellDropDetails}
          applyScoring={applyScoring}
        />
      ),
    },
    {
      title: 'Score Group',
      eventKey: 'scoreGroup',
      content: (
        <DefaultScores
          selectedWellDetails={[wellDropDetails]}
          selectedWellsScores={selectedWellScores as ScoresOfWellDrops[][]}
          applyScoring={applyScoring}
        />
      ),
    },
    {
      title: 'Auto Score',
      eventKey: 'autoScore',
      content: (
        <MarcoScore
          wellDetails={wellDropDetails}
          handleOnMarkDisputedScore={handleOnMarkDisputedScore}
        />
      ),
    },
  ];
  return (
    <div
      id="searchandfilter-score-panel-wrapper"
      className="container-fluid p-0 border h-full"
    >
      <div id="searchandfilter-score-panel-tab-wrapper" className="row h-full">
        <div id="searchandfilter-score-panel-tab-container" className="col-md-12 h-full">
          <RMTabs
            tabItems={tabItems}
            defaultActiveKey={'filter'}
            id={'searchandfilter-score-panel-tab-scoreTab'}
          />
        </div>
      </div>
    </div>
  );
};

export default ScoresPanel;
